
<template>
<div class="container-fluid" style="margin-left:0;padding-left:1.5rem;width:100%">
      <header class="d-flex justify-content-between align-items-center py-3 border-bottom">
      <!-- 왼쪽 정렬: 김프모아 -->
      <a href="/" class="navbar-brand d-flex align-items-center text-dark text-decoration-none">
        <h3 class="mb-0" style="color:#60666b;font-family: 'Noto Sans KR', sans-serif; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);font-weight: bold;">김프모아</h3>
      </a>

    <!-- 모바일에서는 햄버거 메뉴로 숨겨지고 데스크탑에서는 오른쪽에 메뉴 배치 -->
    <ul class="nav nav-pills d-none d-md-flex">
      <li class="nav-item"><a href="/" class="nav-link" style="color:#60666b" aria-current="page">HOME</a></li>
      <li class="nav-item"><a href="/SystemSetup" class="nav-link active" aria-current="page">SETTING</a></li>
      <li class="nav-item"><a href="/Guide" class="nav-link" aria-current="page" style="color: #60666b;">GUIDE</a></li>
      <!--
      <li class="nav-item"><a href="#" class="nav-link" aria-current="page" style="color: #60666b;">미국주식</a></li>
      -->
    </ul>

    <!-- 모바일 햄버거 메뉴 -->
    <button class="navbar-toggler d-md-none ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <!--
     <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    -->
    

    <!--
        <ul class="nav nav-pills">
          <li class="nav-item"><a href="#" class="nav-link active" aria-current="page">코인</a></li>
          <li class="nav-item"><a href="#" class="nav-link" aria-current="page">미국주식</a></li>
          
          <li class="nav-item"><a href="#" class="nav-link">설정</a></li>
          
          <li class="nav-item"><a href="#" class="nav-link" style="color:#60666b">About</a></li>
          
        </ul>
        -->
      </header>
      <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav" style="text-align: right;">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" href="/">HOME</a>
        </li>
        <li class="nav-item" style="color:#60666b">
          <a class="nav-link mob_active" href="/SystemSetup" style="color:#60666b">SETTING</a>
        </li>
        <li class="nav-item" style="color:#60666b">
          <a class="nav-link" href="/Guide" style="color:#60666b">GUIDE</a>
        </li>
        <!--
        <li class="nav-item">
          <a class="nav-link disabled">Disabled</a>
        </li>
        -->
      </ul>
    </div>
    </div>
    <div class="info-bar" style="display: flex; align-items: center; gap: 30px;height:40px">
    </div>
  <div class="container mt-5" style="padding-bottom: 50px;">
    <!--
    <h2 class="mb-4">설정 페이지</h2>
    -->
    <!-- 설정 초기화 -->
     <div class="row">
      <!-- 설정 초기화 -->
      <div class="col-md-12">
        <div class="card mb-3" style="max-width:100%">
          <div class="card-body">
            <h5 class="card-title">설정 초기화</h5>
            <p class="card-text">모든 설정값을 기본값으로 되돌립니다.</p>
            <button class="btn btn-danger w-100" @click="resetSettings">초기화</button>
          </div>
        </div>
      </div>
     </div>

    <!-- 설정 복사 & 붙여넣기 (한 줄로 배치) -->
    <div class="row">
      <!-- 설정 복사 -->
      <div class="col-md-6">
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="card-title">1.설정 복사</h5>
            <p class="card-text">현재 설정을 클립보드에 복사합니다.</p>
            <button class="btn btn-primary w-100" @click="copySettings">설정 복사</button>
          </div>
        </div>
      </div>

      <!-- 설정 붙여넣기 -->
      <div class="col-md-6">
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="card-title">2.설정 붙여넣기</h5>
            <p class="card-text">클립보드에서 설정을 가져와 적용합니다.</p>
            <button class="btn btn-success w-100" @click="pasteSettings">설정 붙여넣기</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      
      
      <div class="col-md-12 mb-4">
        <div class="card shadow-sm" style="max-width:100%">
          <!--
          <h5 class="card-title mt-4">설정 메뉴얼</h5>
          -->
          <div class="card-body">
            <p class="card-text" style="text-align:left;">설정을 복사하여 다른 브라우저에서 붙여넣으면, 다른 브라우저에서도 동일하게 사용가능합니다.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-dark text-white text-center py-1 fixed-bottom" style="font-size:0.8rem">
      Copyright © 2025 kimpmoa. All Rights Reserved.
      <br>
      <a href="/PrivacyPolicy" class="text-white mx-2" style="font-size:0.7rem">개인정보처리방침</a> |
      <a href="/TermsOfService" class="text-white mx-2" style="font-size:0.7rem">이용약관</a> |
      <a href="/about" class="text-white mx-2" style="font-size:0.7rem">사이트소개</a>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {
      settings: {
        theme: "light",
        notifications: true,
        language: "ko"
      }
    };
  },
  methods: {
    resetSettings() {
      if (confirm("정말로 모든 설정을 초기화하시겠습니까?")) {
        // 쿠키 제거
        const allCookies = Cookies.get();
        for (let cookie in allCookies) {
          Cookies.remove(cookie);
        }
        // localStorage 제거
        localStorage.clear();
        alert("설정이 초기화되었습니다.");
      }
    },
    copySettings() {
      const cookies = Cookies.get();
      const localStorageData = JSON.stringify(localStorage);

      const settings = {
        cookies,
        localStorage: localStorageData,
      };
      // 직렬화된 데이터를 클립보드에 복사
      const settingsString = JSON.stringify(settings);
      navigator.clipboard.writeText(settingsString).then(() => {
        alert('설정이 클립보드에 복사되었습니다.');
      }).catch(err => {
        alert('클립보드 복사 실패: ' + err);
      });
    },

    async pasteSettings() {
       navigator.clipboard.readText().then((text) => {
        const settings = JSON.parse(text);

        // 쿠키 설정
        for (let cookieName in settings.cookies) {
          Cookies.set(cookieName, settings.cookies[cookieName]);
        }

        // localStorage 설정
        const localStorageData = JSON.parse(settings.localStorage);
        for (let key in localStorageData) {
          localStorage.setItem(key, localStorageData[key]);
        }

        alert('설정이 복원되었습니다.');
      }).catch(err => {
        alert('클립보드 읽기 실패: ' + err);
      });
    }
  }
};
</script>

<style scoped>

.mob_active{
  font-weight: bold;
  color:#60666b;
}
.card {
  max-width: 600px;
  margin: auto;
}
.fixed-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.container {
  margin-top: 100px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.fs-4 {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  align-items: center;
  align-content: space-between;
  justify-content: center;
}
.align-left{
  text-align: left;
  font-size: 0.8rem;
  vertical-align: middle;
  white-space: nowrap;
}
.align-right{
  text-align: right;
  font-size: 0.8rem;
  vertical-align: middle;
  white-space: nowrap;
}
.p0{  
    padding: 0.3rem 0 0.3rem 0;
}
.bongStyle{
  border: 1px solid #60666b;font-size:0.8rem;
}
.bongSelect{
  background-color: #A6A6A6;
}
.index-search {
  width:100%;
  border:var(--bs-border-width) solid var(--bs-highlight-color);
}
.btn-outline-dark {
    --bs-btn-color: #000;;
    --bs-btn-border-color: #60666b;;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #60666b;;
    --bs-btn-hover-border-color: #60666b;;
    --bs-btn-focus-shadow-rgb: 33, 37, 41;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #60666b;;
    --bs-btn-active-border-color: #60666b;;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #60666b;;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #60666b;;
    --bs-gradient: none;
}
.nav-pills {
    --bs-nav-pills-border-radius: var(--bs-border-radius);
    --bs-nav-pills-link-active-color: #fff;
    --bs-nav-pills-link-active-bg: #60666b;
}
.nav {
    --bs-nav-link-padding-x: 1rem;
    --bs-nav-link-padding-y: 0.5rem;
    --bs-nav-link-font-weight: ;
    --bs-nav-link-color: #60666b;
    --bs-nav-link-hover-color: #60666b;
    --bs-nav-link-disabled-color: var(--bs-secondary-color);
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}
.cursor-pointer{
   cursor: pointer;
}
.info-bar {
    background-color: black;
    color: white;
    text-align: center;
    padding: 10px 0;
    font-size: 16px;
    position: sticky;
    top: 0;
    z-index: 1020; /* 네비게이션 바 위에 배치 */
}

/* 내용이 가려지지 않도록 패딩 추가 */
.row {
    padding-top: 30px; /* 네비게이션 바 + 정보 바 높이만큼 여백 */
}
.navbar-toggler {
  width: 25px;
  height: 22px;
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.navbar-toggler span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #adb5bd;
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
}
</style>
